import { cn } from "@genuin/ui/lib/utils";

import type { SVGIconsProps } from "../type";

export function CommunitiesIcon({ className, ...restProps }: SVGIconsProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={cn(className)}
      {...restProps}
    >
      <path
        d="M7 19C6.89362 19 6.78723 19 6.66755 19C5.82979 19 5.1117 19.1188 4.53989 19.2613C4.04787 19.38 3.48936 19.5819 3.02394 19.9145C2.54521 20.247 2.11968 20.734 2.0266 21.4109C1.9867 21.7316 2 22.4086 2.0133 22.7886C2.0266 23.4774 2.6516 24 3.40957 24H6.53457"
        stroke="#1D1F20"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.4659 24H28.5937C29.3524 24 29.978 23.4656 29.9913 22.7886C29.9913 22.4086 30.0179 21.7316 29.978 21.4109C29.8981 20.734 29.4589 20.247 28.9797 19.9145C28.5139 19.5938 27.9549 19.3919 27.4624 19.2613C26.89 19.1188 26.1713 19 25.3328 19C25.2263 19 25.1065 19 25 19"
        stroke="#1D1F20"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0957 18.4653C13.0361 18.2327 14.3898 18 16 18C17.6102 18 18.9639 18.2327 19.9043 18.4653C20.3888 18.5878 20.973 18.7592 21.486 19.0286C22.0132 19.3102 22.5405 19.7265 22.7969 20.351C22.8682 20.5102 22.9109 20.6939 22.9537 20.8776C23.0249 21.3061 22.9964 22.2612 22.9822 22.751C22.9537 23.449 22.284 24 21.486 24H10.514C9.71603 24 9.04631 23.4612 9.01781 22.751C9.00356 22.2612 8.97506 21.3061 9.04631 20.8776C9.07481 20.6816 9.13181 20.5102 9.20305 20.351C9.45954 19.7265 9.98677 19.3102 10.514 19.0286C11.027 18.7592 11.6112 18.5878 12.0957 18.4653Z"
        stroke="#1D1F20"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23 12.4941C23 11.1164 24.1137 10 25.5 10C26.8863 10 28 11.1164 28 12.4941C28 13.8717 26.8863 15 25.5 15C24.1137 15 23 13.8717 23 12.4941Z"
        stroke="#1D1F20"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 11.0071C12 8.79679 13.7936 7 16 7C18.2064 7 20 8.79679 20 11.0071C20 13.2175 18.2064 15 16 15C13.7936 15 12 13.2175 12 11.0071Z"
        stroke="#1D1F20"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 12.4941C4 11.1164 5.11374 10 6.5 10C7.88626 10 9 11.1164 9 12.4941C9 13.8717 7.88626 15 6.5 15C5.11374 15 4 13.8717 4 12.4941Z"
        stroke="#1D1F20"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
